import {connect} from 'react-redux';
import ModalSendFinalPDF from './ModalSendFinalPDF';
import {showGlobalErrorMessage} from "../../actions/globalErrorMessage/showGlobalErrorMessage";

export default connect(
  null,
  {showGlobalErrorMessage}
)(ModalSendFinalPDF);
